module.exports = __webpack_public_path__ + "img/product03.1e41f423.png";